/**
 * Capitaliza a primeira letra de uma string.
 *
 * @param {string} str - String a ser capitalizada
 * @returns {string} String capitalizada
 */
export function capitalize(str) {
  if (!str || typeof str !== 'string') return '';
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}

/**
 * Extrai o primeiro nome de um nome completo e capitaliza.
 *
 * @param {string} fullName - Nome completo (pode ser só primeiro nome ou nome completo)
 * @returns {object} { firstName: string, restOfName: string }
 */
export function extractFirstName(fullName) {
  if (!fullName || typeof fullName !== 'string') {
    return { firstName: '', restOfName: '' };
  }

  const trimmed = fullName.trim();
  if (!trimmed) {
    return { firstName: '', restOfName: '' };
  }

  const parts = trimmed.split(/\s+/);
  const firstName = parts[0] || '';
  const restOfName = parts.slice(1).join(' ') || '';

  return {
    firstName: capitalize(firstName),
    restOfName: capitalize(restOfName),
  };
}

